import React from 'react';
import { IconProps, IconWrap } from './IconWrap';

export const IconBack = ({ color = '#697595', width = 23, height = 11, ...props }: IconProps) => {
    return (
        <IconWrap {...props} viewBox="0 0 23 11" width={width} height={height} iconClass="back">
            <path
                d="M6.53519 1.39164C6.73046 1.19638 6.73046 0.879796 6.53519 0.684534C6.33993 0.489272 6.02335 0.489272 5.82809 0.684534L0.974533 5.53809L5.82809 10.3916C6.02335 10.5869 6.33993 10.5869 6.53519 10.3916C6.73046 10.1964 6.73046 9.8798 6.53519 9.68453L2.88875 6.03809L21.6816 6.03809C21.9578 6.03809 22.1816 5.81423 22.1816 5.53809C22.1816 5.26194 21.9578 5.03809 21.6816 5.03809L2.88875 5.03809L6.53519 1.39164Z"
                fill={color}
            />
        </IconWrap>
    );
};
